export default __webpack_public_path__ + "static/media/candado.6e50c30e.svg";